var config = require("./lib/config");

var luvitedu = luvitedu || {};

module.exports = luvitedu;

//BEGIN Handle new treeview
luvitedu.nodeToUnselect;
luvitedu.selectedNodeId;

var objMenuContainer;
var objDocumentActions;
var objMainContent;
var objResizeBar;
var objShowResizeBar;
var objResizeHelper;
var objDocHider;
var documentScrollHeight;
var mainContentDistanceFromBottom = 0;

var API;
var API_1484_11;

luvitedu.initLMSAPI = function () {
  API = new LMSAPI();
  API_1484_11 = new LMSAPI2004();
};

luvitedu.initLayout = function () {
  objMenuContainer = document.getElementById("divMenuContainer");
  objDocumentActions = document.getElementById("divDocumentActions");
  showHideEditIcon(false);

  if (!objDocumentActions) {
    objDocumentActions = top.document.getElementById("divDocumentActions");
  }

  objMainContent = document.getElementById("divMainContent");
  objDocHider = $("#divDocHider");

  if (!enableMT) {
    $(".menu").addClass("hidden");
  }

  if (luvitedu.StartWithDocActions) {
    luvitedu.showHideDocActions(true);
    luvitedu.updateDocumentActions();
  } else luvitedu.showHideDocActions(false);

  luvitedu.goToStartPage();

  objDocHider.hide();
  if (StartWithContent && !m_currentRestartNode) {
    luvitedu.startWithContent();
  } else if (m_currentRestartNode) {
    luvitedu.setActiveNode(m_currentRestartNode);
    startNodeFromLastVisited();
  }
};

luvitedu.showHideDocActions = function (show) {
  if (!objDocumentActions) {
    objDocumentActions = top.document.getElementById("divDocumentActions");
  }

  if ($(".nav").is(":visible")) {
    objDocumentActions.style.display = "none";
    if (show) $("#ToggleDocToolbar").removeClass("hidden");
    else $("#ToggleDocToolbar").addClass("hidden");
  } else objDocumentActions.style.display = show ? "block" : "none";
};

luvitedu.getNavTreeIdObj = function () {
  var obj = document.getElementById("hdnNavTreeId");

  if (obj) return obj;
  else {
    obj = top.document.getElementById("hdnNavTreeId");

    return obj;
  }
};

luvitedu.getTreeViewObj = function () {
  var obj = document.getElementById("CustTreeView");

  if (obj) return obj;
  else {
    obj = top.document.getElementById("CustTreeView");
    return obj;
  }
};

luvitedu.getActiveNavtreeId = function () {
  const activeElement = document.querySelector(".navtree li.active");
  return activeElement ? activeElement.id : null;
};

luvitedu.getFirstNavtreeId = function () {
  const firstElement = document.querySelector(
    '.navtree li:not([data-type="0"])',
  );
  return firstElement ? firstElement.id : null;
};

luvitedu.setActiveNode = function (navTreeId) {
  document.querySelectorAll("#navtree .active").forEach(function (el) {
    el.classList.remove("active");
  });
  const element = document.getElementById(navTreeId);
  if (element) {
    element.classList.add("active");
  }
};

luvitedu.getNavTreeIdFromFrameUrlObj = function () {
  var obj = document.getElementById("contentFrameNavTreeId");

  if (obj) return obj;
  else {
    obj = top.document.getElementById("contentFrameNavTreeId");
    return obj;
  }
};

luvitedu.goToStartPage = function (daObj) {
  var iFrameMainContentLocationHref = "";
  try {
    iFrameMainContentLocationHref = iFrameMainContent.document.location.href;
  } catch (e) {} // Will catch access error

  var luvitTop;

  if (parent.opener) {
    try {
      if (typeof parent.opener.luvit.getLuvitTopPage == "function") {
        luvitTop = parent.opener.luvit.getLuvitTopPage();
      } else {
        luvitTop = luvit.getLuvitTopPage();
      }
    } catch (err) {
      luvitTop = luvit.getLuvitTopPage();
    }
  } else {
    luvitTop = luvit.getLuvitTopPage();
  }

  if (AlternativeStartPageUrl != null && AlternativeStartPageUrl != "") {
    luvitTop.iFrameMainContent.document.location.href = AlternativeStartPageUrl;
    AlternativeStartPageUrl = "";
  } else if (
    iFrameMainContentLocationHref
      .substring(iFrameMainContentLocationHref.length - StartPageUrl.length)
      .toLowerCase() != StartPageUrl.toLowerCase()
  ) {
    // Only load if location is different
    luvitTop.iFrameMainContent.document.location.href = StartPageUrl;
  }

  if (daObj) daObj.blur();

  luvitedu.showHideDocActions(false);
};

function goToCMStartPage(daObj) {
  var navTreeId;

  if (TempStartWithContent) {
    navTreeId = TempStartPageNavTreeID;
    TempStartWithContent = false;
  } else {
    navTreeId = CMStartPageNavTreeID;
  }

  if (luvitedu.getActiveNavtreeId() != null) {
    if ($(".treeview-tree").length == 0)
      iFrameMainContent.location =
        ViewDocUrl + "?navtreeid=" + luvitedu.getActiveNavtreeId();
    else luvitedu.expandTreeToNode(luvitedu.getActiveNavtreeId());
  } else {
    if ($(".treeview-tree").length == 0)
      iFrameMainContent.location = ViewDocUrl + "?navtreeid=" + navTreeId;
    else luvitedu.expandTreeToNode(navTreeId);
  }

  if (daObj) {
    daObj.blur();
  }

  luvitedu.showHideDocActions(true);
}

luvitedu.goToFirstNode = function (daObj) {
  if (FirstNodeNavTreeID) luvitedu.expandTreeToNode(FirstNodeNavTreeID);
  luvitedu.showHideDocActions(true);
};

luvitedu.TreeView_getNodes = function (value) {
  var node = document.getElementById(value);

  if (!node) var node = top.document.getElementById(value);
  TreeNodeToSelectFromBookmark(node);
};

TreeNodeToSelectFromBookmark = function (node) {
  luvitedu.TreeNodeToSelect(node);

  if (iFrameMainContent)
    iFrameMainContent.location = ViewDocUrl + "?navtreeid=" + node.id;
  else top.iFrameMainContent.location = ViewDocUrl + "?navtreeid=" + node.id;

  //Make sure the parents are expanded
  var myNode = WebForm_GetParentByTagName(node, "TABLE"); // get the node

  luvitedu.ExpandTopParentNode(myNode);
};

luvitedu.ExpandTopParentNode = function (myNode) {
  if (myNode.id != null) {
    if (
      myNode.id != "" &&
      myNode.id.substr(myNode.id.length - 5, 5) == "Nodes"
    ) {
      nodeSubExpandCollapse(myNode, true);
    }
  }
  if (myNode.parentNode.id != null) {
    if (myNode.parentNode.id == "divToolbar") {
      return;
    }
    if (myNode.parentNode != null) {
      luvitedu.ExpandTopParentNode(myNode.parentNode);
    }
  }
  return;
};

/**
 * @deprecated
 */
luvitedu.resetTree = function (keepState) {
  //Tidigare version av reset stängde alla expanderade block
};

var counter = 0;
const NO_OF_TRIES = 5;
luvitedu.startWithContent = function (navTreeId) {
  if (counter < NO_OF_TRIES) {
    counter++;
    const navTreeElement = document.querySelector(".navtree");
    if (navTreeElement && navTreeElement.children.length > 0) {
      const activeNavtreeId = luvitedu.getFirstNavtreeId();
      luvitedu.setActiveNode(activeNavtreeId);
      if (navTreeId || activeNavtreeId) {
        luvitedu.expandTreeToNode(navTreeId || activeNavtreeId);
        counter = 0;
      }
    } else {
      setTimeout(() => {
        luvitedu.startWithContent(navTreeId);
      }, 500);
    }
  } else {
    counter = 0;
  }
};

luvitedu.TreeNodeToSelect = function (node) {
  if (node != null) {
    luvitedu.updateDocumentActions(node.id);
  }
  luvitedu.showHideDocActions(true);
  luvitedu.setActiveNode(node.id);
  luvitedu.updateUrl(node.id);
};

luvitedu.updateUrl = function (navTreeId) {
  const currentNavTreeId = window.luvit.GetQueryString("navtreeid");
  if (currentNavTreeId === navTreeId) return;

  const currentUrl = window.location.href;
  const newUrl = currentUrl.replace(
    "navtreeid=" + currentNavTreeId,
    "navtreeid=" + navTreeId,
  );
  history.replaceState(null, "", newUrl);
};

luvitedu.OpenSearch = function () {
  luvit.OpenWin(SearchUrl, 640, 480);
  return false;
};

var foundNode;
luvitedu.expandTreeToNode = function (navTreeId) {
  showComments(navTreeId);
  eduutils.DeselectCourseMenu();
  iFrameMainContent.window.location = ViewDocUrl + "?navtreeid=" + navTreeId;
};

luvitedu.expandTreeToNodeWithoutRedirect = function (navTreeId) {
  showComments(navTreeId);
  eduutils.DeselectCourseMenu();
};

function showComments(navTreeId) {
  if (luvit.getItem("loadCommentsInCourse") == "true") {
    luvit.removeItem("loadCommentsInCourse");

    $("iframe.iframe-maincontent").one("load", function () {
      loadComments(navTreeId);
    });
  } else {
    $("#CommentsPopup").hide();
  }
}

luvitedu.OpenTreeNodeInNewWindow = function (navTreeId) {
  luvitedu.expandTreeToNodeWithoutRedirect(navTreeId);
  if (iFrameMainContent)
    iFrameMainContent.window.open(
      ViewDocUrl + "?navtreeid=" + navTreeId,
      "",
      "width=800px,height=600px,resizable=yes,scrollbars=yes",
    );
  else
    top.iFrameMainContent.window.open(
      ViewDocUrl + "?navtreeid=" + navTreeId,
      "",
      "width=800px,height=600px,resizable=yes,scrollbars=yes",
    );
};

function expandTreeToNodeForSearch(navTreeId, navTreeIdFull) {
  findNodeByValue(luvitedu.getTreeViewObj(), navTreeId);
  if (foundNode != null) moveTreeToNodeFromSearch(foundNode, navTreeIdFull);
  else alert("_Bookmark not found");
}

function findNodeByValue(treeviewObj, value) {
  foundNode = null;

  startNodes = treeviewObj.getNodes();
  searchNodesRecursive(startNodes, value);
}

function searchNodesRecursive(nodes, value) {
  var i;
  for (i = 0; i < nodes.length; i++) {
    if (nodes[i].getValue() == value) {
      foundNode = nodes[i];
      return;
    }
    if (nodes[i].getNodes().length > 0)
      searchNodesRecursive(nodes[i].getNodes(), value);
  }
}

function moveStep(dir) {
  findNodeByValue(luvitedu.getTreeViewObj(), luvitedu.getActiveNavtreeId());

  //Find ancestors and expand them all
  ancestors = foundNode.getAncestors();
  for (i = 0; i < ancestors.length; i++) {
    ancestors[i].expand();
  }

  //Find the index of the currently selected node. From that, select the next/previous node
  if (foundNode.getParentTreeNode() == null)
    objParent = foundNode.getParentTreeView();
  else objParent = foundNode.getParentTreeNode();

  siblings = objParent.getNodes();

  var selectedNodeIndex;
  for (i = 0; i < siblings.length; i++) {
    if (siblings[i].getValue() == foundNode.getValue()) {
      //We have found the selected node
      selectedNodeIndex = i;

      //Abort if there is no "previous" node
      if (selectedNodeIndex == 0 && dir == "prev") {
        return;
      }
      if (selectedNodeIndex == siblings.length - 1 && dir == "next") {
        return;
      }
    }
  }
  if (dir == "prev") targetNode = siblings[selectedNodeIndex - 1];
  else if (dir == "next") targetNode = siblings[selectedNodeIndex + 1];

  moveTreeToNode(targetNode);
}

function moveTreeToNode(node) {
  if (node.getDropGroup() != "folder") {
    //Deselect the currently selected nodes (if any)
    luvitedu.getTreeViewObj().unselectAll();

    node.select();

    //Update the navtreeid
    //luvitedu.setSele = node.getValue();
    iFrameMainContent.window.location =
      ViewDocUrl + "?navtreeid=" + node.getValue();
    updateDocumentActions();

    ancestors = node.getAncestors();
    for (i = 0; i < ancestors.length; i++) {
      ancestors[i].expand();
    }

    if (node.getDropGroup() == "nodocactions") {
      luvitedu.showHideDocActions(false);
    } else {
      luvitedu.showHideDocActions(true);
    }
  }
}

function moveTreeToNodeFromSearch(node, NavTreeFullID) {
  if (node.getDropGroup() != "folder") {
    //Deselect the currently selected nodes (if any)
    luvitedu.getTreeViewObj().unselectAll();

    node.select();

    iFrameMainContent.window.location =
      ViewDocUrl + "?navtreeid=" + NavTreeFullID;
    updateDocumentActions();

    ancestors = node.getAncestors();
    for (i = 0; i < ancestors.length; i++) {
      ancestors[i].expand();
    }

    if (node.getDropGroup() == "nodocactions") {
      luvitedu.showHideDocActions(false);
    } else {
      luvitedu.showHideDocActions(true);
    }
  }
}

function closeAllMenuItems() {
  objArr = document.getElementById("divToolbar").getElementsByTagName("a");
  for (i = 0; i < objArr.length; i++) {
    if (objArr[i].id.indexOf("lnkMain") != -1) closeMenuItem(objArr[i], true);
  }
}
function closeMenuItem(daObj) {
  var objToToggle = daObj.nextSibling;
  daObj.className = "";
  return;

  //daObj.parentNode.className = "";
  if (!objToToggle) return;
  if (objToToggle.nodeType == 3) {
    objToToggle = objToToggle.nextSibling;
  }

  objToToggle.style.display = "none";
  daObj.className = "";
  daObj.parentNode.className = "";
}

window.toggleSubMenuItem = function (daObj) {
  daObj.blur();
  if (
    daObj.className == "coursematerial" &&
    typeof allowHideNavTree != "undefined" &&
    allowHideNavTree == false
  ) {
    return;
  }

  var objToToggle = daObj.nextSibling;
  if (objToToggle == null) return;

  if (objToToggle.nodeType == 3) {
    objToToggle = objToToggle.nextSibling;
  }
  imgObj = daObj.getElementsByTagName("img")[0];
  if (objToToggle.style.display == "" || objToToggle.style.display == "none") {
    objToToggle.style.display = "block";
    imgObj.src = imgObj.src.replace("foldout_arrow_side", "foldout_arrow_down");
    if (!isLastChild(daObj.parentNode)) daObj.parentNode.className = "opened";
  } else {
    objToToggle.style.display = "none";
    imgObj.src = imgObj.src.replace("foldout_arrow_down", "foldout_arrow_side");
    daObj.parentNode.className = daObj.parentNode.className.replace(
      "opened",
      "",
    );
  }
  daObj.blur();
};

window.subItemClicked = function (daObj) {
  try {
    if (luvitedu.getTreeViewObj() != null) {
      luvitedu.getTreeViewObj().unselectAll();
    }
  } catch (ex) {
    luvit.getLuvitTopPage().TreeView_unselectAll();
  } //Anja

  luvitedu.showHideDocActions(false);

  daObj.blur();
};

function isLastChild(daObj) {
  return (
    daObj.nextSibling == null ||
    (daObj.nextSibling.nodeType == 3 && daObj.nextSibling.nextSibling == null)
  );
}

luvitedu.administrateNavTree = function () {
  try {
    iFrameMainContent.document.body.style.display = "none";
  } catch (ex) {}
  luvitedu.showHideDocActions(false);
  return true;
};

luvitedu.updateDocumentActions = function (nodeId = null) {
  if (top.packageMode) return;
  cbObj2 = document.getElementById("cbBookmark");
  label = document.getElementById("plhMain_gnLblBookmark");

  if (cbObj2 != null) {
    cbObj2.disabled = true;
  }
  if (label != null) {
    label.disabled = true;
  }
  if (nodeId) {
    // Add a small delay to ensure other initialization code can be processed first
    setTimeout(() => {
      ajaxSend(
        "GET",
        `${baseAppUrl}/education/xmlhttp/handleinfobarrequest.aspx?navtreeid=${nodeId}&action=getdocumentstatusvalues`,
        updateDocumentActions_handleReturn,
        null,
        true,
      );
    }, 100);
  }
};

luvitedu.setBookmark = function (daObj) {
  if (daObj.checked) {
    myStatus = "true";
    action = "addbookmark";
  } else {
    myStatus = "false";
    action = "deletebookmark";
  }

  ajaxSend(
    "GET",
    baseAppUrl +
      "/education/xmlhttp/handleinfobarrequest.aspx?navtreeid=" +
      luvitedu.getActiveNavtreeId() +
      "&action=" +
      action +
      "&status=" +
      myStatus,
  );
};

function updateDocumentActions_handleReturn(xmlObj) {
  try {
    showHideEditIcon(luvit.getXmlValue(xmlObj, "usercanedit", "val") == "1");

    updateBookmark(luvit.getXmlValue(xmlObj, "isfavorite", "val") == "1");
    updateComments(xmlObj);

    setDocumentActionVisibility(
      luvit.getXmlValue(xmlObj, "hidefolderitems", "val") == "1",
    );
  } catch (ex) {
    console.log(ex.message);
  }
}

function setDocumentActionVisibility(noShow) {
  if (noShow) {
    cbObj = document.getElementById("cbBookmark");
    label = document.getElementById("plhMain_gnLblBookmark");

    if (cbObj == null) {
      return;
    }
    cbObj.disabled = true;
    label.disabled = true;

    if (getNodeLinkObj() == null) {
      return;
    }
    luvit.disableLink(getNodeLinkObj());
  } else {
    cbbObj = document.getElementById("cbBookmark");
    label = document.getElementById("plhMain_gnLblBookmark");

    if (cbbObj == null) {
      return;
    }
    cbbObj.disabled = false;
    label.disabled = false;

    if (getNodeLinkObj() == null) {
      return;
    }
    luvit.enableLink(getNodeLinkObj());
  }
}

function updateBookmark(myStatus) {
  cbObj = document.getElementById("cbBookmark");
  label = document.getElementById("plhMain_gnLblBookmark");

  if (cbObj == null) {
    return;
  }

  cbObj.checked = myStatus;
  cbObj.disabled = false;
  label.disabled = false;
}

//This inserts a context menu into the document in iFrameMainContent,
//but only for html-files in the virtual folder /luvitcontentfiles/
function initDocumentContextMenu() {
  try {
    if (
      iFrameMainContent.document.location.href.indexOf("/luvitcontentfiles/") >
        -1 &&
      iFrameMainContent.document.location.href.indexOf(".htm") > -1
    ) {
      var oDoc = iFrameMainContent.window.document;
      oDoc.oncontextmenu = showIframeContextMenu;

      menuobj = oDoc.createElement("div");
      menuobj.id = "iframemaincontent_contextmenu";
      menuobj.className = "luvitcontextmenu";

      //TODO: Replace the hard coded language values with js variables initiated on main.aspx
      menuobj.innerHTML =
        '<a href="#" onclick="luvit.getLuvitTopPage().editDocument();">_Edit content</a>';
      oDoc.body.appendChild(menuobj);

      createStyleRule(
        oDoc,
        ".luvitcontextmenu",
        "font-family:verdana, arial; position:absolute; visibility:hidden; z-index:100; border:1px solid #000; border-width:1px 1px 0px 1px; background-color:#fff;",
      );
      createStyleRule(
        oDoc,
        ".luvitcontextmenu a",
        "display:block; padding:4px 8px 4px 8px; border-bottom:1px solid black; text-decoration:none; font-size:11px;",
      );
      createStyleRule(
        oDoc,
        ".luvitcontextmenu a:link",
        "color:#000; text-decoration:none;",
      );
      createStyleRule(
        oDoc,
        ".luvitcontextmenu a:visited",
        "color:#000; text-decoration:none;",
      );
      createStyleRule(
        oDoc,
        ".luvitcontextmenu a:hover",
        "background-color:#666; color:#fff; text-decoration:none;",
      );
      createStyleRule(
        oDoc,
        ".luvitcontextmenu a:active",
        "color:000; text-decoration:none;",
      );
      addEvent(oDoc, "click", hideIframeContextMenu);
    }
  } catch (ex) {}
}

function hideIframeContextMenu() {
  var oDoc = iFrameMainContent.window.document;
  if (oDoc.getElementById("iframemaincontent_contextmenu") != null) {
    oDoc.getElementById("iframemaincontent_contextmenu").style.visibility =
      "hidden";
  }
}

function showIframeContextMenu(e) {
  var ie5 = document.all && document.getElementById;
  var ns6 = document.getElementById && !document.all;
  var oDoc = iFrameMainContent.window.document;
  var oWin = iFrameMainContent.window;
  if (ie5 || ns6) {
    var menuobj;
    if (oDoc.getElementById("iframemaincontent_contextmenu") != null) {
      menuobj = oDoc.getElementById("iframemaincontent_contextmenu");
    }

    //Find out how close the mouse is to the corner of the window

    var rightedge = ie5
      ? oDoc.body.clientWidth - oWin.event.clientX
      : oWin.innerWidth - e.clientX;
    var bottomedge = ie5
      ? oDoc.body.clientHeight - oWin.event.clientY
      : oWin.innerHeight - e.clientY;

    //if the horizontal distance isn't enough to accomodate the width of the context menu
    if (rightedge < menuobj.offsetWidth) {
      //move the horizontal position of the menu to the left by it's width
      menuobj.style.left = ie5
        ? oDoc.body.scrollLeft + oWin.event.clientX - menuobj.offsetWidth
        : oWin.pageXOffset + e.clientX - menuobj.offsetWidth;
    } else {
      //position the horizontal position of the menu where the mouse was clicked
      menuobj.style.left = ie5
        ? oDoc.body.scrollLeft + oWin.event.clientX
        : oWin.pageXOffset + e.clientX;
    }

    //same concept with the vertical position
    if (bottomedge < menuobj.offsetHeight) {
      menuobj.style.top = ie5
        ? oDoc.body.scrollTop + oWin.event.clientY - menuobj.offsetHeight
        : oWin.pageYOffset + e.clientY - menuobj.offsetHeight;
    } else {
      menuobj.style.top = ie5
        ? oDoc.body.scrollTop + oWin.event.clientY
        : oWin.pageYOffset + e.clientY;
    }

    menuobj.style.visibility = "visible";
    return false;
  }
}

function showHideEditIcon(show) {
  spanObj = document.getElementById("spEditIcons");
  spanObj2 = document.getElementById("EditDocumentProperties");

  if (show) {
    spanObj.style.display = "";
    spanObj2.style.display = "";
    canEdit = true;
  } else {
    spanObj.style.display = "none";
    spanObj2.style.display = "none";
    canEdit = false;
  }
}

function updateComments(xmlObj) {
  var isAdmin = luvit.getXmlValue(xmlObj, "userisadmin", "val");
  var commentsEnabled = luvit.getXmlValue(xmlObj, "commentsenabled", "val");
  var commentsVisibleToStudents = luvit.getXmlValue(
    xmlObj,
    "commentsvisibletostudents",
    "val",
  );
  var noOfComments = luvit.getXmlValue(xmlObj, "nrofcomments", "val");
  var isNKScoordinator = luvit.getXmlValue(
    xmlObj,
    "userisNKScoordinator",
    "val",
  );

  if (getCommentsLinkObj() == null) {
    return;
  }

  if (isAdmin == "1") {
    $(".doccomments").show();
    $("#spnNrOfComments").html(noOfComments);

    if (commentsEnabled == "1") {
      luvit.deFadeLink(getCommentsLinkObj());
    } else {
      luvit.fadeLink(getCommentsLinkObj());
    }
  } else {
    if (commentsEnabled == "1") {
      luvit.enableLink(getCommentsLinkObj());
      $(".doccomments").show();

      if (commentsVisibleToStudents == "1") {
        $("#spnNrOfComments").show();
        $("#spnNrOfComments").html(noOfComments);
      } else {
        $("#spnNrOfComments").html("");
        $("#spnNrOfComments").hide();
      }
    } else {
      luvit.disableLink(getCommentsLinkObj());
      $(".doccomments").hide();
      return;
    }
  }
}

luvitedu.editDocument = function (linkObj) {
  if (packageMode || canEdit) {
    iFrameMainContent.location =
      EditDocUrl + "?navtreeid=" + luvitedu.getActiveNavtreeId();
  }

  if (typeof linkObj != "undefined") {
    linkObj.blur();
  }
};

luvitedu.editDocumentProperties = function (linkObj) {
  if (packageMode || canEdit)
    iFrameMainContent.location =
      EditDocPropertiesUrl +
      "?navtreeid=" +
      luvitedu.getActiveNavtreeId() +
      "&prp=0";
  if (typeof linkObj != "undefined") {
    linkObj.blur();
  }
};

luvitedu.printContent = function (daObj, errMsg) {
  //Ändrat för att pres templates ska fungera att printa i IE
  var browser = navigator.appName;
  var boo = browser == "Microsoft Internet Explorer";

  try {
    if (iFrameMainContent.window.frames.length == 0 || !boo) {
      iFrameMainContent.focus();
      iFrameMainContent.window.print();
    } else {
      var stage = iFrameMainContent.window.frames["myStage"];
      if (stage == null)
        var stage = iFrameMainContent.window.frames["cg_stage"];
      if (stage != null) {
        stage.focus();
        stage.print();
      } else {
        iFrameMainContent.focus();
        iFrameMainContent.window.print();
      }
    }
  } catch (ex) {
    alert(errMsg);
  }
  daObj.blur();
  return false;
};

luvitedu.openComments = function (daObj, evt) {
  daObj.blur();
  $("#CommentsPopup").css("left", evt.pageX + "px");

  $("#CommentsPopup").show();

  return false;
};

luvitedu.openNotes = function (daObj) {
  daObj.blur();
  if (luvit.linkIsDisabled(daObj)) return false;
  luvit.OpenWin(
    "notes/documentnotes.aspx?navtreeid=" + luvitedu.getActiveNavtreeId(),
    800,
    600,
  );
  return false;
};

function highlightIFrameContent(arrSearchTerms) {
  var objArr = new Array();

  //Only highlight search terms if this is an html document
  if (iFrameMainContent.document.location.href.indexOf(".htm") > -1) {
    try {
      objArr[0] = iFrameMainContent.document.getElementsByTagName("body")[0];
      initHighlight(arrSearchTerms, objArr, true);
    } catch (ex) {}
  }
}

//This fixes a Safari bug which causes the resizing of the left hand menu to be erratic.
var is_safari =
  navigator.userAgent.toLowerCase().indexOf("safari") != -1 &&
  navigator.userAgent.toLowerCase().indexOf("mac") != -1
    ? true
    : false;
function fixSafari() {
  if (!is_safari) return;

  if (document.getElementById("divSafariFixer") == null) {
    myDiv = document.createElement("div");
    myDiv.style.visibility = "hidden";
    document.getElementsByTagName("body")[0].appendChild(myDiv);
  } else {
    myDiv = document.getElementById("divSafariFixer");
  }
  myDiv.innerHTML = navTreeWidth;
}

function OpenLinkInLuvitTop(link) {
  luvit.getLuvitTopPage().document.location.href = link;
}
